import { Link } from '@ace-clublabs/shared-component-library';
import { ClubCode } from './constants';
import { ReactElement } from 'react';

export const FEE_AMOUNT_PLACEHOLDER = '<FEE-AMOUNT>';

export enum ClubContentName {
  ContactPhoneText = 'CONTACT_PHONE_TEXT',
  CodeClubUrl = 'CLUB_URL',
  ERSNotEligibleContent = 'ERS_NOT_ELIGIBLE_CONTENT',
  ADOMinimumAgeWarning = 'ADO_MINIMUM_AGE_WARNING',
  MDOMinimumAgeWarning = 'MDO_MINIMUM_AGE_WARNING',
  RVToolTip = 'RV_TOOL_TIP',
}

export interface ClubContent {
  name: ClubContentName;
  value?: string | ReactElement;
}

const californiaRvToolTip =
  'Optional roadside for RV/motorcycle: This option provides 4 additional allowable calls per member household for RV/motorcycle tows, extrication and winching and RV tire changes service. Up to $500 per RV/motorcycle service call, up to a total of $1,000 per household per membership year on such calls. Member pays all other costs above those amounts. Effective 7 calendar days after upgrade is processed, and receipt of full payment due.';
const nonCaliforniaRvToolTip =
  'Optional roadside for RV/motorcycle: This option provides RV/motorcycle tows, extrication and winching and RV tire changes on any of your 4 allowable service calls per membership year. Up to $500 per RV/motorcycle service call, up to a total of $1,000 per household per membership year on such calls. Member pays all other costs above those amounts. Effective 7 calendar days after upgrade is processed, and receipt of full payment due.';

const alabama: ClubContent[] = [
  {
    name: ClubContentName.ContactPhoneText,
    value: '1-800-521-8124',
  },
  {
    name: ClubContentName.CodeClubUrl,
    value: 'alabama',
  },
  {
    name: ClubContentName.ERSNotEligibleContent,
    value: `A $${FEE_AMOUNT_PLACEHOLDER} non-refundable service fee applies each time you use Roadside Assistance for the first three days of your new membership. Benefits for Plus, Premier, and RV/motorcycle take effect after 7 days. Classic benefits start the first day subject to the service fee.`,
  },
  {
    name: ClubContentName.RVToolTip,
    value: nonCaliforniaRvToolTip,
  },
];

const calif: ClubContent[] = [
  {
    name: ClubContentName.ContactPhoneText,
    value: '1-877-428-2277',
  },
  {
    name: ClubContentName.CodeClubUrl,
    value: 'calif',
  },
  {
    name: ClubContentName.ERSNotEligibleContent,
    value: `A $${FEE_AMOUNT_PLACEHOLDER} non-refundable service fee applies each time you use Roadside Assistance for the first three days of your new membership. Benefits for Plus, Premier, and RV/motorcycle take effect after 7 days. Classic benefits start the first day subject to the service fee.`,
  },
  {
    name: ClubContentName.RVToolTip,
    value: californiaRvToolTip,
  },
];

const hawaii: ClubContent[] = [
  {
    name: ClubContentName.ContactPhoneText,
    value: '1-800-736-2886',
  },
  {
    name: ClubContentName.CodeClubUrl,
    value: 'hawaii',
  },
  {
    name: ClubContentName.ERSNotEligibleContent,
    value: `A $${FEE_AMOUNT_PLACEHOLDER} non-refundable service fee applies each time you use Roadside Assistance for the first three days of your new membership. Benefits for Plus and Premier take effect after 7 days. Classic benefits start the first day subject to the service fee.`,
  },
  {
    name: ClubContentName.RVToolTip,
    value: nonCaliforniaRvToolTip,
  },
];

const northernnewengland: ClubContent[] = [
  {
    name: ClubContentName.ContactPhoneText,
    value: '1-800-222-3612',
  },
  {
    name: ClubContentName.CodeClubUrl,
    value: 'northernnewengland',
  },
  {
    name: ClubContentName.ERSNotEligibleContent,
    value: `A $${FEE_AMOUNT_PLACEHOLDER} non-refundable service fee applies each time you use Roadside Assistance for the first three days of your new membership. Benefits for Plus, Premier, and RV/motorcycle take effect after 7 days. Classic benefits start the first day subject to the service fee.`,
  },
  {
    name: ClubContentName.RVToolTip,
    value: nonCaliforniaRvToolTip,
  },
];

const autoclubmo: ClubContent[] = [
  {
    name: ClubContentName.ContactPhoneText,
    value: '1-877-374-5116',
  },
  {
    name: ClubContentName.CodeClubUrl,
    value: 'autoclubmo',
  },
  {
    name: ClubContentName.ERSNotEligibleContent,
    value: `A $${FEE_AMOUNT_PLACEHOLDER} non-refundable service fee applies each time you use Roadside Assistance for the first three days of your new membership. Benefits for Plus, Premier, and RV/motorcycle take effect after 7 days. Classic benefits start the first day subject to the service fee.`,
  },
  {
    name: ClubContentName.RVToolTip,
    value: nonCaliforniaRvToolTip,
  },
];

const eastcentral: ClubContent[] = [
  {
    name: ClubContentName.ContactPhoneText,
    value: '1-800-441-5008',
  },
  {
    name: ClubContentName.CodeClubUrl,
    value: 'eastcentral',
  },
  {
    name: ClubContentName.ERSNotEligibleContent,
    value: `A $${FEE_AMOUNT_PLACEHOLDER} non-refundable service fee applies each time you use Roadside Assistance for the first three days of your new membership. Benefits for Plus, Premier, and RV/motorcycle take effect after 7 days. Classic benefits start the first day subject to the service fee.`,
  },
  {
    name: ClubContentName.ADOMinimumAgeWarning,
    value: (
      <>
        Associates that are 18 years and under can be added to a membership with the Annual Dues Option after you have
        purchased your membership online, by calling{' '}
        <Link target="_blank" sx={{ fontSize: '1rem !important' }} href="tel:8004415008">
          800-441-5008
        </Link>{' '}
        or by completing an online form located at{' '}
        <Link href="https://aaa.com/juniorassociate" target="_blank" sx={{ fontSize: '1rem !important' }}>
          AAA.com/juniorassociate
        </Link>
        . Junior Associates (ages 16 -18) will be added at no extra charge.
      </>
    ),
  },
  {
    name: ClubContentName.MDOMinimumAgeWarning,
    value: (
      <>
        Associates that are 18 years and under are not eligible for the Monthly Dues Option. So if you wish to add them,
        you need to select the Annual Dues Option to purchase your membership online and add these Associates to your
        membership afterwards by calling{' '}
        <Link target="_blank" sx={{ fontSize: '1rem !important' }} href="tel:8004415008">
          800-441-5008
        </Link>{' '}
        or by completing an online form located at{' '}
        <Link href="https://aaa.com/juniorassociate" target="_blank" sx={{ fontSize: '1rem !important' }}>
          AAA.com/juniorassociate
        </Link>
        . Junior Associates (ages 16 -18) will be added at no extra charge.
      </>
    ),
  },
  {
    name: ClubContentName.RVToolTip,
    value: nonCaliforniaRvToolTip,
  },
];

const texas: ClubContent[] = [
  {
    name: ClubContentName.ContactPhoneText,
    value: '1-800-765-0766',
  },
  {
    name: ClubContentName.CodeClubUrl,
    value: 'texas',
  },
  {
    name: ClubContentName.ERSNotEligibleContent,
    value: `A $${FEE_AMOUNT_PLACEHOLDER} non-refundable service fee applies each time you use Roadside Assistance for the first three days of your new membership. Benefits for Plus, Premier, and RV/motorcycle take effect after 7 days. Classic benefits start the first day subject to the service fee.`,
  },
  {
    name: ClubContentName.RVToolTip,
    value: nonCaliforniaRvToolTip,
  },
];

const tidewater: ClubContent[] = [
  {
    name: ClubContentName.ContactPhoneText,
    value: '1-800-501-4222',
  },
  {
    name: ClubContentName.CodeClubUrl,
    value: 'tidewater',
  },
  {
    name: ClubContentName.ERSNotEligibleContent,
    value: `A $${FEE_AMOUNT_PLACEHOLDER} non-refundable service fee applies each time you use Roadside Assistance for the first three days of your new membership. Benefits for Plus, Premier, and RV/motorcycle take effect after 7 days. Classic benefits start the first day subject to the service fee.`,
  },
  {
    name: ClubContentName.RVToolTip,
    value: nonCaliforniaRvToolTip,
  },
];

const newmexico: ClubContent[] = [
  {
    name: ClubContentName.ContactPhoneText,
    value: '1-877-222-1020',
  },
  {
    name: ClubContentName.CodeClubUrl,
    value: 'newmexico',
  },
  {
    name: ClubContentName.ERSNotEligibleContent,
    value: `A $${FEE_AMOUNT_PLACEHOLDER} non-refundable service fee applies each time you use Roadside Assistance for the first three days of your new membership. Benefits for Plus, Premier, and RV/motorcycle take effect after 7 days. Classic benefits start the first day subject to the service fee.`,
  },
  {
    name: ClubContentName.RVToolTip,
    value: nonCaliforniaRvToolTip,
  },
];

const unknown: ClubContent[] = [
  {
    name: ClubContentName.ContactPhoneText,
    value: '1-877-428-2277',
  },
  {
    name: ClubContentName.CodeClubUrl,
    value: 'unknown',
  },
  {
    name: ClubContentName.ERSNotEligibleContent,
    value: `A $${FEE_AMOUNT_PLACEHOLDER} non-refundable service fee applies each time you use Roadside Assistance for the first three days of your new membership. Benefits for Plus, Premier, and RV/motorcycle take effect after 7 days. Classic benefits start the first day subject to the service fee.`,
  },
  {
    name: ClubContentName.RVToolTip,
    value: nonCaliforniaRvToolTip,
  },
];

const clubContents = {
  [ClubCode.alabama]: alabama,
  [ClubCode.calif]: calif,
  [ClubCode.hawaii]: hawaii,
  [ClubCode.northernnewengland]: northernnewengland,
  [ClubCode.autoclubmo]: autoclubmo,
  [ClubCode.eastcentral]: eastcentral,
  [ClubCode.texas]: texas,
  [ClubCode.tidewater]: tidewater,
  [ClubCode.newmexico]: newmexico,
  [ClubCode.unknown]: unknown,
};

export const getClubContent = (name: string, club: string | undefined): string | ReactElement => {
  if (!club) {
    return '';
  }

  const item = clubContents[club]?.filter((i) => i.name === name)[0];

  if (item == null || item == undefined || item.value == null || item.value == undefined) return '';

  return item?.value;
};
